<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- Left Panel -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Receive Info
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row>
                  <v-col cols="12">
                    <v-autocomplete
                      label="Delivery Order"
                      v-model="requisition_delivery_master_id"
                      :items="deliveryList"
                      item-title="code"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      :error-messages="errors.requisition_delivery_master_id"
                      @update:model-value="changeDelivery"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-date-input
                      label="Receive Date"
                      v-model="receive_date"
                      variant="outlined"
                      density="compact"
                      prepend-icon=""
                      clearable
                      hide-details
                      :error-messages="errors.receive_date"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      label="Remarks"
                      v-model="remarks"
                      density="compact"
                      variant="outlined"
                      clearable
                      :error-messages="errors.remarks"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Right Panel -->
        <v-col md="9" cols="12">
          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Receive Details
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row>
                  <v-col cols="12">
                    <v-table density="compact" fixed-header class="table-dotted-border-bottom">
                      <thead>
                        <tr>
                          <th class="text-center">SL</th>
                          <th class="text-center">Code</th>
                          <th class="text-left">Product</th>
                          <th class="text-center">Unit</th>
                          <th class="text-left">Quantity</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr v-for="(item, index) in cart" :key="index">
                          <td class="text-center">{{ index + 1 }}</td>
                          <td>{{ item.product_code }}</td>
                          <td>{{ item.product_name }}</td>
                          <td class="text-center">{{ item.unit_name }}</td>
                          <td>
                            <v-text-field
                              type="number"
                              density="compact"
                              variant="outlined"
                              v-model="item.quantity"
                              hide-details
                            />
                          </td>
                        </tr>

                        <tr v-if="cart.length === 0">
                          <td colspan="5" class="text-center text-red">
                            No items found
                          </td>
                        </tr>
                      </tbody>
                    </v-table>
                  </v-col>
                </v-row>

                <v-divider class="my-2"></v-divider>

                <v-card-actions>
                  <v-row>
                    <v-col cols="8"></v-col>
                    <v-col cols="4" class="d-flex justify-end">
                      <v-btn
                        class="bg-grey-darken-1 me-2"
                        @click="() => submit(0)"
                      >
                        Draft
                      </v-btn>

                      <v-btn
                        class="bg-primary"
                        @click="() => submit(1)"
                      >
                        {{ isEdit ? "Update" : "Save" }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-actions>

              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useForm, useField } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { useRouter, useRoute } from "vue-router";

const store = useStore();
const router = useRouter();
const route = useRoute();

const panel = ref([0]);
const panel2 = ref([0]);
const loading = ref(false);

const isEdit = ref(false);
const receiveId = ref(null);

/* Validation */
const { handleSubmit, setErrors, errors } = useForm({
  validationSchema: yup.object({
    requisition_delivery_master_id: yup.number().required(),
    receive_date: yup.date().required(),
    remarks: yup.string().nullable(),
  }),
});

/* Fields */
const { value: requisition_delivery_master_id } = useField("requisition_delivery_master_id");
const { value: receive_date } = useField("receive_date");
const { value: remarks } = useField("remarks");

/* Data */
const cart = ref([]);

const deliveryList = ref([]);

// computed(() => store.getters.getInvProductionRequisitionDeliveryList || []);

/* Functions */

function changeDelivery() {
  const delivery = deliveryList.value.find(
    d => d.id == requisition_delivery_master_id.value
  );

  if (!delivery) return;

  cart.value = delivery.requisition_delivery_details.map(item => ({
    product_id: item.product_id,
    production_requisition_delivery_detail_id: item.id,
    product_name: item.product?.name,
    product_code: item.product?.code,
    unit_name: item.product?.unit?.name,
    quantity: item.qty - item.receive_qty,
  }));
}

async function loadData(id) {
  try {
    const res = await store.dispatch("getRawMetarialRequisitionReceiveById", id);
    const data = res.data;
    deliveryList.value = [data.delivery_master];
    requisition_delivery_master_id.value = data.requisition_delivery_master_id;
    receive_date.value = data.receive_date;
    remarks.value = data.remarks;
    // 

    cart.value = data.details.map(item => ({
      product_id: item.product_id,
      production_requisition_delivery_detail_id: item.production_requisition_delivery_detail_id,
      product_name: item.product?.name,
      product_code: item.product?.code,
      unit_name: item.product?.unit?.name,
      quantity: item.quantity,
    }));

  } catch (e) {
    toast.error("Load failed");
  }
}

/* Submit */
const submit = (status) => {
  handleSubmit(async (values) => {
    try {
      const payload = {
        ...values,
        id: isEdit.value ? receiveId.value : null,
        status,
        cart: cart.value,
      };

      if (isEdit.value) {
        await store.dispatch("updateRawMetarialRequisitionReceive", payload);
        toast.success("Updated");
      } else {
        await store.dispatch("saveRawMetarialRequisitionReceive", payload);
        toast.success("Saved");
      }

      router.push({ name: "requisition-receive-list" });

    } catch (error) {
      let message = "Error";

      if (error?.response?.data?.errors) {
        setErrors(error.response.data.errors);
        message = Object.values(error.response.data.errors).flat().join("\n");
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      }

      toast.error(message);
    }
  })();
};

/* Load */
onMounted(async () => {
  loading.value = true;

    await store.dispatch("getInvProductionRequisitionDeliveryList", {is_receivable:true}); 
    deliveryList.value = store.getters.getInvProductionRequisitionDeliveryList || [];

  if (route.query.id) {
    isEdit.value = true;
    receiveId.value = route.query.id;
    await loadData(receiveId.value);
  }

  loading.value = false;
});
</script>